<template>
       <div class="AfterSales">
        <div class="AfterSales-menu">
            <div class="AfterSales-menu-breadcrumb">
                <Breadcrumb></Breadcrumb>
            </div>
            <div class="AfterSales-menu-btn">
                <!-- <el-button type="primary">新增分类</el-button> -->
            </div>
        </div>
        <div class="AfterSales-content">
            <div class="AfterSales-content-card">
                <div class="AfterSales-content-card-title">
                    <div style="flex: 1;display: flex;align-items: center;" @click="showMenu = !showMenu">
                        <i class="el-icon-caret-right iconsan"
                            :style="{ transform: showMenu ? 'rotate(90deg)' : 'rotate(0deg)' }"
                            style="font-size: 16px;margin-right: 3px;"></i>
                        分类列表
                    </div>
                    <!-- <i class="el-icon-circle-plus-outline icons" style="font-size: 20px;"></i> -->
                </div>
                <el-collapse-transition>
                    <div class="AfterSales-content-card-list" v-show="showMenu">
                        <div class="AfterSales-content-card-list-item" @click.stop="getAfterSalesListDetail(item.id)"
                            :class="{ 'activeStyle': activeName === item.id }" v-for="item in menu" :key="item.id">
                            <div class="AfterSales-content-card-list-item-left">
                                <!-- <i class="el-icon-star-off" style="font-size:16px;margin-right: 8px;"></i> -->
                                <div>{{ item.t_name }}</div>
                            </div>
                            <div class="AfterSales-content-card-list-item-right">

                            </div>
                        </div>
                    </div>
                </el-collapse-transition>
            </div>
            <div class="AfterSales-content-table">
                <!-- <el-card class="box-card" shadow="hover" v-for="(item, index) in tableData" :key="index"
                    style="margin-bottom: 10px;">
                    <div slot="header" class="clearfix">
                        <span>{{ item.t_name }}</span>
                        <el-link style="float: right;" type="primary">查看 <i class="el-icon-sort-up"
                                style="transform: rotate(90deg) scaleX(-1);"></i>
                        </el-link>
                    </div>
                    <div style="font-size: 14px;color:#636d7e">
                        {{ item.t_content }}
                    </div>
                </el-card> -->
                <el-empty description="暂无可预览信息~" v-if="tableData.length === 0"></el-empty>
                <el-collapse v-else v-model="activeNames" accordion>
                    <el-collapse-item :name="index" v-for="(item, index) in tableData" :key="index">
                        <template slot="title">
                            <div>
                                <span>{{ index + 1 }}、</span>
                                {{ item.t_name }}
                            </div>
                        </template>
                        <div style="background-color: #f5f7fa;padding:20px; border-radius: 10px;">
                            <div style="font-size: 12px;color:#636d7e">
                                {{ item.t_content }}
                            </div>
                            <div style="margin-top: 10px;display:flex;gap:10px;flex-wrap: wrap; align-items: flex-end;">
                                <div v-for="(item, index) in item.t_attachments" :key="index" style="display:flex;">
                                    <el-image v-if="isImageFile(item)"
                                        style="width: 60px; height: 60px;border: 1px solid #EBEEF5;" :src="item.url"
                                        :preview-src-list="[item.url]"> </el-image>
                                    <div v-else @click="readFile(item)"
                                        style="border: 1px solid #409eff;padding:0 10px;cursor: pointer;color: #409eff;background-color: #eef9fe;">
                                        {{ item.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :hide-on-single-page="total <= initParams.page_z" style="margin-top: 20px;"
                    :current-page="initParams.page" :page-size="initParams.page_z"
                    layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="阅览" width="90%" :visible.sync="innerAttachDialog" :append-to-body="true" top="1vh">
            <!-- <div v-if="isVideoPreview">
                <video controls autoplay width="100%" style="height: calc(87vh - 60px); object-fit: contain;">
                    <source :src="previewUrl" type="video/mp4">
                    您的浏览器不支持HTML5视频播放。
                </video>
            </div> -->
            <iframe :src="FileUrl" frameborder="0" width="100%" style="height: calc(87vh - 60px);"></iframe>
        </el-dialog>
    </div>
</template>

<script>
import {
    allAfterSalesCategory,//获取售后分类列表
    getAfterSalesList,//获取售后分类详情
} from "@/api/AfterSalesManage.js";
export default {
    name: "",
    data() {
        return {
            innerAttachDialog: false,
            FileUrl: '',
            activeNames: [],

            showMenu: true,
            menu: [],//分类列表
            activeName: '',
            initParams: {//获取售后分类详情
                page: 1,
                page_z: 10,
                T_category: '',//分类id
                T_name: '',//标题
            },
            tableData: [],//售后分类详情列表
            total: 0,//售后分类详情列表总条数
        }
    },
    mounted() {
        //获取售后分类列表
        this.allAfterSalesCategoryList();
    },
    methods: {
        //每页显示多少
        handleSizeChange(val) {
            this.initParams.page_z = val;
            this.getAfterSalesListDetail(this.activeName, true);
        },
        //多少页
        handleCurrentChange(val) {
            this.initParams.page = val;
            this.getAfterSalesListDetail(this.activeName, true);
        },
        //阅览
        readFile(item) {
            console.log('readFile', item)
            let str = item.url.split('.').pop();
            console.log(str);
            if (['pdf', 'xlsx', 'xls', 'docx', 'doc'].includes(str)) {
                this.FileUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${item.url}`;
            } else {
                this.FileUrl = item.url;
            }
            this.innerAttachDialog = true;
        },
        /**
         * 
         * @param obj 判断是否是图片文件
         * @returns  true false
         */
        isImageFile(obj) {
            if (!obj || typeof obj.name !== 'string') {
                return false;
            }

            // 常见的图片文件扩展名
            const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp', '.tiff'];

            // 获取文件名的小写形式，以便不区分大小写地比较
            const fileName = obj.name.toLowerCase();
            let flag = imageExtensions.some(ext => fileName.endsWith(ext));
            // 检查文件名是否以图片扩展名结尾
            return flag
        },
        //获取售后分类列表
        allAfterSalesCategoryList() {
            allAfterSalesCategory({ page: 1, page_z: 999 }).then(({ data: res }) => {
                if (res.Code == 200) {
                    this.menu = res.Data || [];

                    this.initParams.page = 1;
                    if (this.menu.length > 0) {
                        this.getAfterSalesListDetail(this.menu[0].id);
                    }
                }
            })
        },
        //获取售后分类-->详情
        getAfterSalesListDetail(item, refresh = false) { //refresh为true可以刷新
            this.loading = true;
            if (item == this.activeName && !refresh) {
                return;
            }
            this.activeNames = [];
            this.activeName = item;
            this.initParams.T_category = item;
            getAfterSalesList(this.initParams).then(({ data: res }) => {
                if (res.Code == 200) {
                    this.tableData = res.Data.Data || [];
                    this.total = res.Data.Num || 0;
                }
                setTimeout(() => {
                    this.loading = false;
                }, 500);
            })
        },
    }
}
</script>
<style lang="scss">
.icons:hover {
    color: #409eff;
}

.iconsan {
    transition: transform 0.1s ease-in-out;
}

.AfterSales {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;

    &-menu {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(#fff, 1);
        height: 70px;
        padding: 15px 10px;
        box-shadow: 5px 5px 10px -10px #000;

        &-breadcrumb {
            padding-left: 20px;
        }

        &-btn {
            padding-right: 20px;
        }
    }

    &-content {
        background: rgba(#fff, 1);
        margin: 30px 10px;
        color: #000;
        flex: 1;
        display: flex;

        &-card {
            min-width: 220px;
            border-right: 1px solid #f1f2f4;
            user-select: none;
            padding: 10px;

            &-title {
                font-size: 14px;
                font-weight: bold;
                display: flex;
                justify-content: space-between;
                align-items: center;
                cursor: pointer;
                border-radius: 10px;
                padding: 10px;
                color: #636d7e;
            }

            &-list {
                padding-left: 10px;
                margin-top: 10px;
                display: flex;
                flex-direction: column;
                gap: 5px;

                &-item {
                    cursor: pointer;
                    font-size: 12px;
                    border-radius: 10px;
                    padding: 10px;

                    &:hover {
                        background: #fafafc;
                    }

                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    color: #636d7e;

                    &-left {
                        display: flex;
                        flex: 1;
                        height: 100%;
                        padding-left: 10px;
                    }
                }
            }

        }



        &-table {
            padding: 10px;
            flex: 1;

            &-search {
                display: flex;
                align-items: center;
                justify-content: space-between;

                &-left {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }
            }
        }
    }
}

.activeStyle {
    background: #eef9fe;
    color: #409eff;
}
</style>